import { create } from "zustand";

type ProgressStore = {
  totalQuestions: number;
  validQuestionsCount: number;
  percent: number;
  loading: boolean;
  setProgress: (percent: number) => void;
  setLoading: (loading: boolean) => void;
  setQuestionsCount: (params: { total: number; valid: number }) => void;
};

export const useProgressStore = create<ProgressStore>((set) => ({
  percent: 0,
  loading: false,
  totalQuestions: 0,
  validQuestionsCount: 0,
  setProgress: (percent: number) =>
    set((state) => ({
      ...state,
      percent
    })),
  setLoading: (loading: boolean) =>
    set((state) => ({
      ...state,
      loading
    })),
  setQuestionsCount: ({ total, valid }) =>
    set((state) => ({
      ...state,
      totalQuestions: total,
      validQuestionsCount: valid
    }))
}));
